import V2 from "./v2/loading";

export default function Entry(props) {
    return <V2 {...props} />;
}
